// extracted by mini-css-extract-plugin
export default {"menuPaper":"routing-node-menu_menuPaper__l+I05"};